var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"50","cy":"50","r":"50","fill":"#3672AF","fillOpacity":"0.75","key":0}),React.createElement("path",{"d":"M72.5811 50.0003L38.7101 69.5557L38.7101 30.4449L72.5811 50.0003Z","fill":"white","key":1})]);
}

PlayInline.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
